/**
 * Login block entry.
 *
 * Importing the SCSS here makes Vite bundle the block's CSS alongside its JS.
 * Password show/hide toggle for the login form's password field.
 */

import './index.scss';

const logins = document.querySelectorAll('.login');

if (logins.length) {
	const passwordToggles = document.querySelectorAll('[data-login-password-toggle]');

	passwordToggles.forEach((toggle) => {
		const field = toggle.closest('.login__password');
		const input = field?.querySelector('input');

		if (!input) return;

		const showIcon = toggle.querySelector('.login__eye-icon--show');
		const hideIcon = toggle.querySelector('.login__eye-icon--hide');

		toggle.addEventListener('click', () => {
			const isVisible = input.type === 'text';

			input.type = isVisible ? 'password' : 'text';
			toggle.setAttribute('aria-pressed', String(!isVisible));
			toggle.setAttribute(
				'aria-label',
				isVisible ? toggle.dataset.labelShow : toggle.dataset.labelHide
			);
			showIcon?.toggleAttribute('hidden', !isVisible);
			hideIcon?.toggleAttribute('hidden', isVisible);
		});
	});
}
